import React from 'react';
import { Image } from 'semantic-ui-react';
import WhatsAppImg from '../images/whatsApp.svg';

const WhatsApp = () => {
  const handleClick = () => {
    window.open('https://wa.me/201010616061', '_blank');
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className="whatsapp-button"
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '10px',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Image
        src={WhatsAppImg}
        style={{
          height: '50px',
          width: 'fit-content',
          boxShadow: ' box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5)',
        }}
        size="tiny"
        centered
      />
    </div>
  );
};

export default WhatsApp;



// WEBPACK FOOTER //
// ./app/components/WhatsApp.js